var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMoney = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.739,
    height: 12.492,
    viewBox: "0 0 18.739 12.492",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "money-bill-1-regular",
    d: "M13.013,70.246A3.644,3.644,0,1,1,9.37,66.6,3.642,3.642,0,0,1,13.013,70.246ZM8.849,69.205v2.082h-.26a.521.521,0,1,0,0,1.041H10.15a.521.521,0,1,0,0-1.041H9.89v-2.6a.522.522,0,0,0-.521-.521H8.849a.521.521,0,1,0,0,1.041ZM0,66.082A2.082,2.082,0,0,1,2.082,64H16.657a2.083,2.083,0,0,1,2.082,2.082V74.41a2.084,2.084,0,0,1-2.082,2.082H2.082A2.083,2.083,0,0,1,0,74.41Zm1.562,1.562v5.205a2.083,2.083,0,0,1,2.082,2.082H15.1a2.084,2.084,0,0,1,2.082-2.082V67.644A2.084,2.084,0,0,1,15.1,65.562H3.644A2.083,2.083,0,0,1,1.562,67.644Z",
    transform: "translate(0 -64)",
    fill: "#ffce05"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMoney);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/money.b50b0b887692475f806689c905e91e2b.svg";